var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"architecture py-80px"},[_c('div',{staticClass:"block-content"},[_c('block-title',{attrs:{"en":_vm.architecture.title.en,"title":_vm.architecture.title.value,"sub":_vm.architecture.title.sub}}),_vm._v(" "),_c('img',{staticClass:"mt-80px",attrs:{"src":_vm.architecture.background,"alt":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }